export default function getVideoURL(filename) {
    return `${process.env.GATSBY_VIDEOS_URL}/${filename}`
}
